<!--
 * @Author: ShiWeiShan
 * @Date: 2020-12-22 14:05:51
 * @LastEditTime: 2020-12-23 12:09:50
 * @LastEditors: ShiWeiShan
 * @Description: 代缴费记录列表
 * @FilePath: \fs-js-pcweb-user\src\components\recordListTable\planAdjustList.vue
-->
<template>
  <div class="plan-adjust-list">
    <div class="Workflow-box">
      <div class="Workflow-box-up">
        <span>
          计划年份：
          <el-date-picker
            v-model="planYear"
            type="year"
            value-format="yyyy"
            placeholder="选择年"
            class="Workflow-up-year"
            @input="planYearChange"
          ></el-date-picker>
        </span>
      </div>
      <div class="Workflow-box-body">
        <el-table
          class="martop"
          ref="adjustTable"
          :data="tableData"
          highlight-current-row
          :fit="false"
          stripe
          height="100%"
        >
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column
            prop="code"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="记录编号"
            width="160"
          ></el-table-column>
          <el-table-column
            prop="user_code"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划户编号"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="user_name"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划户名称"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="plan_year"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="计划年份"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="apply_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="申报时间"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="before_sum"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="调整前总量(m³)"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="after_sum"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="调整后总量(m³)"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="adjust_sum"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="调整值(m³)"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="adjust_reason"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="调整理由"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="adjust_statement"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="调整理由说明"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="audit_status"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="审核状态"
            width="200"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.audit_status == '0'">待复核</span>
              <span v-if="scope.row.audit_status == '1'">待审核</span>
              <span v-if="scope.row.audit_status == '2'">审核不通过</span>
              <span v-if="scope.row.audit_status == '3'">已审核</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="audit_opinion"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="审核意见"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="audit_man_name"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="审核人"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="audits_times"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="审核时间"
            width="180"
          ></el-table-column>
          <el-table-column label="处理" fixed="right" width="120" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="type !== 'readOnly'"
                size="small"
                class="btn-marleft"
                type="primary"
                plain
                @click.native.prevent="handleTableToolClik('operation', scope.row)"
              >处理</el-button>
              <el-button
                v-if="type === 'readOnly'"
                size="small"
                class="btn-marleft"
                type="primary"
                plain
                @click.native.prevent="handleTableToolClik('readOnly', scope.row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="type !== 'readOnly'" class="Workflow-box-footer">
        <el-button @click="handleTableToolClik('adjust')" type="success" size="mini">发起新的调整申请</el-button>
      </div>
    </div>

    <hd-loading type="tip" v-if="tipLoading"></hd-loading>
    <common-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :title="dialogOptions.title"
      :width="dialogOptions.width"
      :height="dialogOptions.height"
      append-to-body
      cover
    >
      <adjust-flow-chart
        v-if="dialogName === 'adjust' || dialogName === 'operation' || dialogName === 'readOnly'"
        :adjustData="currentRowData"
        :planYear="planYear"
        :type="adjustType"
        @successThen="successThen"
        @cancel="dialogVisible=false"
      ></adjust-flow-chart>
    </common-dialog>
  </div>
</template>

<script>
import {
  A_ADD_Adjustyearquery // 查询调整用水计划
} from '@/assets/js/axiosPresets'
import adjustFlowChart from "@/components/adjustFlowChart/index" // 调整流程图
import reviewDetail from "@/components/Reviewflowchart/detail" // 详情
export default {
  components: {
    adjustFlowChart,
    reviewDetail
  },
  props: {
    type: String
  },
  data () {
    return {
      planYear: new Date().format('yyyy'),
      tipLoading: false, // loading
      tableData: [], // 列表数据
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      }, // 弹框样式
      dialogVisible: false, // 弹窗是否显示
      currentRowData: {}, // 当前活跃的表格行
      dialogName: '',
      adjustType: 'append'
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  methods: {
    async initData () {
      this.getTableData()
    },
    // 数据：查询收费状态
    async getTableData () {
      const data = {
        user_id: this.userInfo.oid,
        plan_year: this.planYear,
        pageIndex: 1,
        pageSize: 1000,
        sortField: '',
        sortOrder: ''
      }
      this.tipLoading = true
      const wid = await A_ADD_Adjustyearquery(data)
      this.tipLoading = false
      if (wid.data.Content.list) {
        this.tableData = wid.data.Content.list
      }
    },
    planYearChange () {
      this.getTableData()
    },
    handleTableToolClik (type, row) {
      console.log(row, 999)
      this.currentRowData = row || {}
      this.dialogName = type
      switch (type) {
        case 'operation':
          this.adjustType = ''
          this.dialogOptions = {
            title: '水量调整申请',
            width: '800px'
          }
          break
        case 'readOnly':
          this.adjustType = 'readOnly'
          this.dialogOptions = {
            title: '水量调整申请',
            width: '800px'
          }
          break
        case 'adjust':
          this.adjustType = 'append'
          this.dialogOptions = {
            title: '水量调整申请',
            width: '800px'
          }
          break
        case 'details':
          this.dialogOptions = {
            title: '代缴费记录详情',
            width: '800px',
            height: ''
          }
          break
      }
      this.dialogVisible = true
    },
    addNewApply () {

    },
    successThen () {
      setTimeout(() => {
        this.dialogVisible = false
      }, 0)
      this.getTableData()
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.plan-adjust-list {
  height: 582px;
  position: relative;
  .bottom-tools {
    background-color: #fff;
    border-top: $bd-common;
    .tools-box {
      float: right;
      padding: 5px;
      .tools-item {
        display: inline-block;
        margin-left: 6px;
      }
    }
  }
}
</style>